import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { EClubAccess } from '@app/pages/clubs/models/club-model';
import { ClubService } from '@app/pages/clubs/services/club.service';
import { htmlUrls } from '@shared/utils/router-paths';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SnackBarTypes } from "@shared/components/cutome-snack-bar/custome-snack-bar.component";
import { SnackbarService } from '@shared/utils/snackbar.service';


export const clubMemberGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router: Router = inject(Router);
  const clubService: ClubService = inject(ClubService);
  const snackbarService = inject(SnackbarService);

  const id = route.queryParamMap.has('clubId') ? route.queryParamMap.get('clubId')! : route.paramMap.get('id')!;

  return clubService.get(id).pipe(
    map(res => {
      const result = res?.result?.isMember || res?.result?.access === EClubAccess.Global;

      if (!result) {
        snackbarService.openSnackbar(SnackBarTypes.error, "در حال حاضر به این باشگاه دسترسی نداید.");
        router.navigate([htmlUrls.club, id], { replaceUrl: true });
      }

      return result;
    })
  );
};
